import { customers } from '@/api'

const getCustomers = async (context) => {
  context.commit('LOADING_UPDATED', true)
  try {
    if (context.state.customers.length === 0) {
      let response = await customers.fetch()
      context.commit('CUSTOMERS_UPDATED', response.data)
    }
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

export default {
  getCustomers
}



// WEBPACK FOOTER //
// ./src/store/modules/customers/actions.js